/* 👻🚨👻🚨👻 Let op! This code has been auto generated, so best not to touch it 👻🚨👻🚨👻 */
import * as Types from '@repo/graphql-types';

import { useSubscription, type UseSubscriptionArgs } from '@repo/subscriptions'
export type FlowOnlineCountSubscriptionVariables = Types.Exact<{ [key: string]: never; }>;


export type FlowOnlineCountSubscription = { __typename?: 'Subscription', flowOnlineCount: number };



export function useFlowOnlineCountSubscription(options: Omit<UseSubscriptionArgs<FlowOnlineCountSubscription, FlowOnlineCountSubscriptionVariables>, "subscription">) {
          return useSubscription<FlowOnlineCountSubscription, FlowOnlineCountSubscriptionVariables>({
            subscription: FlowOnlineCountDocument,
            ...options,
          })
}

export const FlowOnlineCountDocument = `subscription flowOnlineCount {
  flowOnlineCount
}`